import axios from '@/api';
import authHeader from "@/services/auth-header";

class MainSubtitleContext {
    normalizeUrlSlashes(url) {
        const parts = url.split("://");

        if (parts.length !== 2) {
            return url;
        }

        return `${parts[0]}://${parts[1].replace(/\/{2,}/g, "/")}`;
    }

    async request(file, sync = 0) {
        const baseName = file.replace(/\.[^/.]+$/, "");
        const ext = file.split(".").pop().toLowerCase();

        let url =
            process.env.VUE_APP_API_URL +
            `file/smi/${baseName}.${ext}?sync=${sync}`;

        url = this.normalizeUrlSlashes(url);

        try {
            const response = await axios.get(url, {
                headers: {
                    ...authHeader(),
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                responseType: "blob",
            });

            if (
                response.status !== 200 ||
                response.data.type === "application/json"
            ) {
                return false;
            }

            return {
                url: URL.createObjectURL(response.data),
                name: `${baseName}.${ext}`,
                ext: `.${ext}`,
            };
        } catch {
            return false;
        }
    }
}

export default new MainSubtitleContext();
